import { useExperiments } from 'state/experiments';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

type VariantFnType = ReturnType<typeof useExperiments>['variant'];

const localStorageVariantFn: VariantFnType = (experimentFlag, expectedVariant) => {
  const experiments = LocalStorage.getItem(StorageKeys.AMPLITUDE_VARIANTS) ?? {};
  const reactNativeNavigationExperiment = experiments[experimentFlag] ?? {};
  return reactNativeNavigationExperiment.value === expectedVariant;
};

// TODO cleanup react navigation code. if react navigation is re-enabled undo other changes associated with this comment.

// This function can be used outside of react contexts
// to get the value in the instant it's called
export function isReactNavigationEnabled(variantFn: VariantFnType = localStorageVariantFn) {
  return false;
  // /*
  //  * React Navigation for web is still in experimental phase
  //  * Fallback to legacy navigation until implemented
  //  * https://reactnavigation.org/docs/web-support/
  //  */
  // if (Platform.OS === 'web') {
  //   return false;
  // }

  // return variantFn(RunningExperiments.ReactNativeNavigation, 'treatment');
}

export const useReactNavigationFlag = () => {
  return false;
  // const { variant } = useExperiments();
  // return isReactNavigationEnabled(variant);
};
